import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DatePickerShowWeekService {
  public calendarSubject: Subject<Date> = new Subject<Date>();

  clear() {
    this.calendarSubject.complete();
    this.calendarSubject = new Subject<Date>();
  }
}
